import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import CustomerDetail from "containers/NhanVay/ChiTietKhachHangNhanVay";

export const BtnChiTietKhachHang = ({ item }) => {
  const [showChiTietKhachHang, setShowChiTietKhachHang] = useState(false);
  const khachHangDetail = {};
  //HIỂN THỊ CHI TIẾT KHÁCH HÀNG
  const setModalChiTietKhachHangShow = (khachHangDetail) => () => {
    if (khachHangDetail)
      setShowChiTietKhachHang(!showChiTietKhachHang, khachHangDetail);
    else setShowChiTietKhachHang(!showChiTietKhachHang);
  };

  return (
    <>
      <a
        href={() => false}
        className="blue btn-link"
        onClick={setModalChiTietKhachHangShow(item)}
      >
        {item.TenChuNo}
      </a>
      {showChiTietKhachHang && (
        <CustomerDetail
          show={showChiTietKhachHang}
          onHide={setModalChiTietKhachHangShow(khachHangDetail)}
          data={item}
        ></CustomerDetail>
      )}
    </>
  );
};
